// Classes de borda estáticas para o Tailwind JIT.
//
// O padrão anterior interpolava o nome da classe em runtime
// (`border-${selected ? 'brand' : 'gray-300'}`), o que impede o Tailwind v4 de
// gerar a classe — a borda de destaque não aparecia. Estes helpers retornam
// sempre nomes de classe completos e estáticos, seguros para o JIT.

export const variationBorderClass = isSelected =>
  isSelected ? 'border-brand' : 'border-gray-300'

const TICKET_DIVIDER_BORDER = {
  delivered: 'border-white',
  canceled: 'border-gray-400'
}

export const ticketDividerBorderClass = status =>
  TICKET_DIVIDER_BORDER[status] ?? 'border-gray-500'
